Vue.component('kiosk-companies-list', require('./KioskCompaniesList').default);
Vue.component('kiosk-companies-table', require('./KioskCompaniesTable').default);
Vue.component('kiosk-company-form', require('./KioskCompanyForm').default);
Vue.component('kiosk-company-edit-form', require('./KioskCompanyEditForm').default);
Vue.component('kiosk-plan-list', require('./KioskPlanList').default);

Vue.component('kiosk-plan-form', require('./KioskPlanForm').default);
Vue.component('kiosk-plan-table', require('./KioskPlanTable').default);
Vue.component('kiosk-company-details', require('./KioskCompanyDetails').default);
Vue.component('kiosk-foreup-list', require('./KioskForeupList').default);
Vue.component('kiosk-healthjump-list', require('./KioskHealthjumpList').default);
Vue.component('kiosk-logs-list', require('./KioskLogsList').default);
Vue.component('kiosk-swell-connector', require('./KioskSwellConnector').default);
Vue.component('fareharbor-logs', require('./KioskFareharborLogs').default);

Vue.component('kiosk-developers', require('./Developers').default);
Vue.component('kiosk-user-delete-button', require('./KioskUserDeleteButton').default);

